import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { createDispatchers } from "@utils/dispatcher";
import { RootState } from "..";
import { MODALS } from "@_constants/modal";

export type ModalProps = {
  closeAction: () => void;
  cancelAction: () => void;
  [key: string]: unknown;
};

export type IModalType = MODALS | null;

export interface IModal {
  isOpen: boolean;
  modalType: IModalType;
  props: ModalProps;
}
export interface IModalState {
  modals: IModal[];
}

export const initialState: IModalState = {
  modals: [],
};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{ modalType: IModalType; props: ModalProps }>,
    ) => {
      state.modals.push({
        isOpen: true,
        modalType: action.payload.modalType,
        props: action.payload.props,
      });
    },
    closeModal: (state, action: PayloadAction<{ modalType: IModalType }>) => {
      state.modals = state.modals.filter(
        (modal) => modal.modalType !== action.payload.modalType,
      );
    },
    updateModalProps: (state, action: PayloadAction<IModal>) => {
      state.modals = state.modals.map((modal: IModal) => {
        if (modal.modalType === action.payload.modalType) {
          return {
            ...modal,
            ...action.payload,
            props: { ...modal.props, ...action.payload.props },
          };
        } else {
          return modal;
        }
      });
    },
    closeTopModal: (state) => {
      state.modals.pop();
    },
    closeAllModals: (state) => {
      state.modals = [];
    },
  },
});

export const { openModal, closeAllModals } = modalSlice.actions;

export const modalDispatcher = createDispatchers(modalSlice.actions);
export const modalSelector = (state: RootState) => state.modal;

export const modalReducer = modalSlice.reducer;
